import styled from 'styled-components';

import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)<{$bottomOffset: number}>`
  position: ${platform.isWeb ? 'fixed' : 'absolute'};
  inset: 0 0 ${p => p.$bottomOffset || 0}px 0;
  align-items: center;
  justify-content: center;

  /* To be above the Notifications on web */
  z-index: 3001;
`;
